import React from 'react';
import { TableBody, TableCell, TableRow } from '@mui/material';
import AvatarImg from '../../../../shared/components/avatar-img';
import { EmptyRows } from '../../../../shared/components';
import tableHelper from '../../../../shared/utils/table-helper';
import useTableContext from '../../../../context/table/context';
import { Trial } from '../../../../models';
import trialsTableService from '../../services/trials-table-service';
import getTrialSideLabel from '../../../../shared/utils/get-trial-side-label';
import TrialsStatusLabel from '../trials-status-label/trials-status-label';
import dateHelper from '../../../../shared/utils/date-helper';
import trialsTableBodyService from '../../services/trials-table-body-service';
import DeadlineDate from '../deadline-date/deadline-date';
import formatTrialNumber from '../../../../shared/utils/trial/format-trial-number';

interface Props {
  trials: Trial[];
  page: number,
  onSelectTrial: (trial: Trial) => void,
}

export default function TrialsTableBody({
  trials, page, onSelectTrial,
}: Props) {
  const { defaultRowsPerPage } = useTableContext();
  const effectiveRowsPerPage = Math.floor(defaultRowsPerPage * 1.5);

  return (
    <TableBody>
      {tableHelper.getTablePageRecords(trials, page, effectiveRowsPerPage)
        .map((trial, index) => {
          const labelId = `trials-table-${index}`;

          return (
            <TableRow
              hover
              tabIndex={-1}
              key={trial.trialId}
              sx={{
                backgroundColor: trialsTableBodyService.calcTrialRowColor(trial),
              }}
              onClick={() => { onSelectTrial(trial); }}
            >
              <TableCell id={labelId} align="left">
                {trial.trialId}
              </TableCell>
              <TableCell align="center">
                <AvatarImg name={trial.responsible?.name} size={30} />
              </TableCell>
              <TableCell align="left">
                {trial.createdAt && dateHelper.getLocaleDate(trial.createdAt)}
              </TableCell>
              <TableCell align="left">
                <DeadlineDate deadline={trial.deadline} isLate={trialsTableBodyService.isTrialPastDue(trial)} />
              </TableCell>
              <TableCell align="center">
                <TrialsStatusLabel status={trial.status} />
              </TableCell>
              <TableCell align="left">
                {trial.trialType}
              </TableCell>
              <TableCell align="left">
                <p className="text-purple-main font-medium">
                  {tableHelper.getLimitedCellTextContent(trial.task.name)}
                </p>
              </TableCell>
              <TableCell align="left">
                {trial.trialNumber && formatTrialNumber(trial.trialNumber.toString())}
              </TableCell>
              <TableCell align="left">
                {trial.plaintiff && tableHelper.getLimitedCellTextContent(trial.plaintiff)}
              </TableCell>
              <TableCell align="left">
                {trial.defendant && tableHelper.getLimitedCellTextContent(trial.defendant)}
              </TableCell>
              <TableCell align="left">
                {trial.office?.name && tableHelper.getLimitedCellTextContent(trial.office.name)}
              </TableCell>
              <TableCell align="left">
                {trial.lawyer && tableHelper.getLimitedCellTextContent(trial.lawyer)}
              </TableCell>
              <TableCell align="left">
                {tableHelper.getLimitedCellTextContent(trial.client.name)}
              </TableCell>
              <TableCell align="left">
                <p className="font-bold">
                  {trial.region}
                </p>
              </TableCell>
              <TableCell align="left">
                {trial.side && getTrialSideLabel(trial.side)}
              </TableCell>
              <TableCell align="left">
                {trial.privateAnnotations && tableHelper.getLimitedCellTextContent(trial.privateAnnotations)}
              </TableCell>
              <TableCell align="left">
                {trial.publicAnnotations && tableHelper.getLimitedCellTextContent(trial.publicAnnotations)}
              </TableCell>
            </TableRow>
          );
        })}

      <EmptyRows
        page={page}
        recordsAmount={trials.length}
        columnsAmount={trialsTableService.columnsAmount}
      />
    </TableBody>
  );
}
